import React from 'react';
import {Form, Textarea, Button, List} from 'components';
import {useNamedSelector} from 'helpers';

export function VisionAndMe() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'my-vision-and-me' })}>
      <List small-gutter>
        <List.Title>Who do you need to be (as a person) to create and live your desired Life Vision?</List.Title>
        <Textarea name="1" />
        <List.Title>How do you need to grow and change to create your dream?</List.Title>
        <Textarea name="2" />
        <List.Title>Are you ready and willing to make a commitment to be that person?</List.Title>
        <Textarea name="3" />
      </List>
      <p className="medium-spacing text-right">
        <Button className="primary" to="/goals/" rightIcon="arrow-right">Set Your Goals</Button>
      </p>
    </Form>
  );
}
